<script lang="ts" setup>
import { computed, type PropType } from 'vue'

interface AlarmItem {
  timestamp: string | Date
  alarmId: number | bigint
  alarmNames: string[]
}

const props = defineProps({
  alarmsData: {
    type: Array as PropType<AlarmItem[]>,
    required: true,
    default: () => []
  }
});

const formatDate = (d: string | Date) => {
  if (!d) return '-'
  return new Date(d).toLocaleString('no-NO', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

const hasData = computed(() => props.alarmsData && props.alarmsData.length > 0);

const headers = [
  { title: 'Time', key: 'timestamp', width: '200px' },
  { title: 'Active Alarms', key: 'alarmNames', sortable: false },
];
</script>

<template>
  <v-container fluid>
    <v-alert
      v-if="!hasData"
      type="info"
      variant="tonal"
      class="mb-4"
    >
      No Alarms recorded.
    </v-alert>

    <v-card v-else elevation="2">
      <v-card-title class="text-subtitle-1 font-weight-bold bg-grey-lighten-4">
        Alarms List
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="alarmsData"
        density="compact"
        class="text-body-2"
        hover
      >
        <template v-slot:item.timestamp="{ item }">
          <span class="text-medium-emphasis">{{ formatDate(item.timestamp) }}</span>
        </template>

        <template v-slot:item.alarmNames="{ item }">
          <div v-if="item.alarmNames && item.alarmNames.length > 0" class="d-flex flex-wrap ga-2 py-2">
            <v-chip
              v-for="alarm in item.alarmNames"
              :key="alarm"
              color="error"
              variant="tonal"
              size="small"
              class="font-weight-bold"
            >
              {{ alarm }}
            </v-chip>
          </div>
          <span v-else class="text-disabled font-italic">-</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.font-monospace {
  font-family: 'Courier New', Courier, monospace !important;
}
</style>